import { useState, useEffect } from 'react';
import { usuariosService } from '../../services';
import { formatDateTime } from '../../utils/format';
import './Usuarios.css';

export default function Usuarios() {
  const [usuarios, setUsuarios] = useState([]);
  const [perfis, setPerfis] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modal, setModal] = useState(null);
  const [form, setForm] = useState({ username: '', nome: '', email: '', senha: '', perfil_id: '', ativo: true });

  const carregar = async () => {
    setLoading(true);
    try {
      const [u, p] = await Promise.all([usuariosService.listar(), usuariosService.perfis()]);
      setUsuarios(u.data);
      setPerfis(p.data);
    } catch {}
    setLoading(false);
  };

  useEffect(() => { carregar(); }, []);

  const abrirNovo = () => {
    setForm({ username: '', nome: '', email: '', senha: '', perfil_id: perfis[0]?.id || '', ativo: true });
    setModal('novo');
  };

  const abrirEditar = (u) => {
    const perfilId = perfis.find(p => p.nome === u.perfil)?.id || '';
    setForm({ username: u.username, nome: u.nome, email: u.email || '', senha: '', perfil_id: perfilId, ativo: u.ativo });
    setModal(u.id);
  };

  const salvar = async (e) => {
    e.preventDefault();
    try {
      if (modal === 'novo') {
        await usuariosService.criar(form);
      } else {
        await usuariosService.atualizar(modal, form);
      }
      setModal(null);
      carregar();
    } catch {}
  };

  if (loading) return <div className="loading"><div className="spinner"></div>Carregando...</div>;

  return (
    <div className="usuarios-page">
      <div className="usuarios-header">
        <h1>👥 Usuários</h1>
        <button className="btn btn-primary" onClick={abrirNovo}>+ Novo Usuário</button>
      </div>

      <div className="table-container card">
        <table>
          <thead>
            <tr><th>Usuário</th><th>Nome</th><th>Perfil</th><th>Ativo</th><th className="col-ultimo-acesso">Último Acesso</th><th>Ações</th></tr>
          </thead>
          <tbody>
            {usuarios.map(u => (
              <tr key={u.id}>
                <td><strong>{u.username}</strong></td>
                <td>{u.nome}</td>
                <td><span className="badge badge-info" style={{textTransform:'capitalize'}}>{u.perfil}</span></td>
                <td><span className={`badge ${u.ativo ? 'badge-success' : 'badge-danger'}`}>{u.ativo ? 'Sim' : 'Não'}</span></td>
                <td className="col-ultimo-acesso">{u.ultimo_acesso ? formatDateTime(u.ultimo_acesso) : '-'}</td>
                <td><button className="btn btn-sm btn-secondary" onClick={() => abrirEditar(u)}>✏️ Editar</button></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {modal !== null && (
        <div className="modal-overlay" onClick={() => setModal(null)}>
          <div className="modal-content" onClick={e => e.stopPropagation()}>
            <h2>{modal === 'novo' ? 'Novo Usuário' : 'Editar Usuário'}</h2>
            <form onSubmit={salvar}>
              <div className="form-group">
                <label>Username</label>
                <input value={form.username} onChange={e => setForm({...form, username: e.target.value})} required disabled={modal !== 'novo'} />
              </div>
              <div className="form-group">
                <label>Nome</label>
                <input value={form.nome} onChange={e => setForm({...form, nome: e.target.value})} required />
              </div>
              <div className="form-group">
                <label>E-mail</label>
                <input type="email" value={form.email} onChange={e => setForm({...form, email: e.target.value})} />
              </div>
              <div className="form-group">
                <label>{modal === 'novo' ? 'Senha' : 'Nova Senha (deixe vazio para manter)'}</label>
                <input type="password" value={form.senha} onChange={e => setForm({...form, senha: e.target.value})} {...(modal === 'novo' ? {required:true} : {})} />
              </div>
              <div className="form-group">
                <label>Perfil</label>
                <select value={form.perfil_id} onChange={e => setForm({...form, perfil_id: e.target.value})} required>
                  {perfis.map(p => <option key={p.id} value={p.id} style={{textTransform:'capitalize'}}>{p.nome}</option>)}
                </select>
              </div>
              {modal !== 'novo' && (
                <div className="form-group">
                  <label>
                    <input type="checkbox" checked={form.ativo} onChange={e => setForm({...form, ativo: e.target.checked})} /> Ativo
                  </label>
                </div>
              )}
              <div className="modal-actions">
                <button type="button" className="btn btn-secondary" onClick={() => setModal(null)}>Cancelar</button>
                <button type="submit" className="btn btn-primary">Salvar</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
